import { walletRoutes } from 'routers/private/wallet-routes';
import { templateRoutes } from 'routers/private/template-routes';
import { campaignRoutes } from 'routers/private/campaign-routes';
import { startedRoutes } from 'routers/private/started-routes';
import { advertiserRoutes } from 'routers/private/advertiser-routes';
import { audiencesRoutes } from 'routers/private/audiences-routes';
import { creativeRoutes } from 'routers/private/creatives-routes';
import { ownTemplateRoutes } from 'routers/private/own-template-routes';
import { PlusOutlinedIcon } from 'components/Atoms/Icon';
import { analyticRoutes } from 'routers/private/analytic-routes';
import { USER_LEVEL_TYPE } from 'constants/common';
import { t } from 'utilities/lang';

export default [
  {
    ...campaignRoutes[1],
    name: t('route.create_new_campaign'),
    showMenu: true,
    defaultShow: true,
    hasBorderBt: true,
    icon: PlusOutlinedIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  ...advertiserRoutes,
  ...audiencesRoutes,
  ...campaignRoutes,
  ...creativeRoutes,
  ...ownTemplateRoutes,
  ...analyticRoutes,
  ...templateRoutes,
  ...walletRoutes,
];
